import type { Failure } from "@/modules/shared/failure";
import { renderFieldErrors } from "@/modules/shared/fieldCopy";
import { SYSTEM_ERROR, type FormState } from "@/modules/shared/forms";

/**
 * The **web's** copy for the Onboarding commands, and the one place a `Failure`
 * becomes a `FormState` (R22 T6). Every sentence is unchanged from before the
 * cores existed.
 */
export function onboardingCopyFor(failure: Failure): string {
  switch (failure.code) {
    case "registration_already_pending":
      return "You already have a registration pending review.";
    case "registration_already_decided":
      return "This registration was already decided.";
    case "malformed_input":
      // Reached only when the queue posts no registration id, which no screen
      // does. Field-level rejections carry `fieldErrors` and render inline.
      return SYSTEM_ERROR;
    default:
      return SYSTEM_ERROR;
  }
}

export function formStateFor(
  failure: Failure,
  values?: Record<string, string>,
): FormState {
  if (failure.fieldErrors) {
    return { fieldErrors: renderFieldErrors(failure.fieldErrors), values };
  }
  return { formError: onboardingCopyFor(failure), values };
}
